export const BUSINESS_ACCOUNTS_AJAX_PREFIX = '/business_accounts/ajax';
export const BUSINESS_API_PREFIX = '/business/api';
export const BUSINESS_LANDING_PAGE = '/business';
